export const getInteractiveCardByInstanceId = (state, cardInstanceId) => state.interactiveCards.byInstanceId[cardInstanceId];